import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Faq } from "../../faq/Faq"


export const LocationFaq: React.FC = ({
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.location_faq",
  });

  const questions = [
    {
      question: t("question_1.question"),
      answer: {
        richText: [
          {
            type: "paragraph",
            text: t("question_1.answer"),
            spans: [
              {
                start: 149,
                end: 162,
                type: "hyperlink",
                data: {
                  link_type: "Web",
                  url: "/app/",
                },
              },
              {
                start: 431,
                end: 454,
                type: "hyperlink",
                data: {
                  link_type: "Web",
                  url: "/your-first-visit/",
                }
              }
            ]
          }
        ],
        text: t("question_1.answer")
      }
    }, 
    {
      question: t("question_2.question"),
      answer: {
        richText: [
          {
            type: "paragraph",
            text: t("question_2.answer"),
            spans: [],
          }
        ],
        text: t("question_2.answer")
      }    
    },
    {
      question: t("question_3.question"),
      answer: {
        richText: [
          {
            type: "paragraph",
            text: t("question_3.answer"),
            spans: [
              {
                start: 25,
                end: 70,
                type: "hyperlink",
                data: {
                  link_type: "Web",
                  url: "/blog/how-often-can-you-donate-plasma/",
                },
              }
            ]
          }
        ],
        text: t("question_3.answer")
      }
    },
    {
      question: t("question_4.question"),
      answer: {
        richText: [
          {
            type: "paragraph",
            text: t("question_4.answer"),
            spans: [
              {
                start: 406,
                end: 419,
                type: "hyperlink",
                data: {
                  link_type: "Web",
                  url: "/blog/how-much-can-i-earn-as-a-plasma-donor/",
                }
              }
            ]
          }
        ],
        text: t("question_4.answer")
      }
    }
  ]

  return (
    <Faq questions={questions} />
  )
}
